/**
 * @file
 * Provide behavior to change the donation value based on selected frequency.
 */

(function ($, Drupal) {
  Drupal.behaviors.donationFormValue = {
    attach: function attach(context) {

      function setDonationValues() {
        const amountRadios = $('#edit-donation-amount .checkbox');
        amountRadios.addClass('is-hidden-form-item-donation-amount');
        amountRadios.each(function( index ) {
          // Hide amounts, which should not be available for chosen frequency.
          let frequency = $('input:radio[name="donation_frequency"]:checked').val();
          if (!frequency) {
            // If no frequency is set, show options for one time donation.
            frequency = 'once';
          }
          const $input = $(this).find('.checkbox__input[data-frequencies]');
          // Determine allowed amounts by option frequency data.
          const frequencies = $input.attr('data-frequencies').split(',');
          if ($.inArray(frequency, frequencies) !== -1) {
            $(this).removeClass('is-hidden-form-item-donation-amount');
          }
        });
      }

      setDonationValues();

      $('#edit-donation-frequency input[type=radio]').change(function() {
        let frequency = $('input:radio[name="donation_frequency"]:checked').val();
        let amount_label = Drupal.t('Your donation amount');
        let $amount_active = $('input[name*="donation_amount"]:checked');
        frequency = frequency === 0 ? 1 : frequency;

        // Call setDonationValues() to show correct donation values
        setDonationValues();

        // Set wording of the ammount label

        switch (frequency) {
          case '1':
            amount_label = 'Ihr monatlicher Spendenbetrag';
            break;
          case '3':
            amount_label = 'Ihr vierteljährlicher Spendenbetrag';
            break;
          case '6':
            amount_label = 'Ihr halbjährlicher Spendenbetrag';
            break;
          case '12':
            amount_label = 'Ihr jährlicher Spendenbetrag';
            break;
        }

        $('#edit-donation-amount--wrapper .fieldset-legend').contents().replaceWith(amount_label + ' ');

        if ($amount_active.length > 0 && $amount_active.val() !== 'free') {
          $amount_active.get(0).checked = false;
        }
      });

      // Reset value of free-amount textfield
      $('#edit-donation-amount input[type=radio]').change(function() {
        $('#edit-donation-free-amount').val('');
      });
    }
  };
})(jQuery, Drupal);
